import { useState, useEffect } from "react";

const useContainerHeight = () => {
  const [containerHeight, setContainerHeight] = useState(0);

  useEffect(() => {
    const updateContainerHeight = () => {
      const vh = window.innerHeight * 0.01;
      setContainerHeight(window.innerHeight);
      document.documentElement.style.setProperty("--vh", vh);
    };

    updateContainerHeight();
    window.addEventListener("resize", updateContainerHeight);

    return () => {
      window.removeEventListener("resize", updateContainerHeight);
    };
  }, []);

  return containerHeight;
};

export default useContainerHeight;
